
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Input from "components/forms/Input";
import TextArea from "components/forms/TextArea";
import PageWrapper from "components/wrappers/PageWrapper";
import SectionWrapper from "components/wrappers/SectionWrapper";
import { useHistory } from "react-router-dom";
import SettingService from "api/services/SettingService";
import ToggleSwitch from "components/actions/ToggleSwitch";
import BackButton from "components/actions/BackButton";
import ToastAlert from "components/ToastAlert";
import Language from "components/Language";
import DashboardWrapper from "components/wrappers/DashboardWrapper";


const AddMenuOption = () => {

    const { t } = useTranslation();
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [addMenuStatus, setAddMenuStatus] = useState(null)
    const history = useHistory()
    const [isEnabled, setIsEnabled] = useState(false)


    const onAddMenu = (data) => {
        SettingService.createMenu({ ...data, enabled: isEnabled }).then((resp) => {
            setAddMenuStatus("addMenuStatus")
            history.push('/settings/mainmenu')
        }).catch((err) => {
            //Handle error ..
            setAddMenuStatus("error")
        });
    }

    const onCancel = () => {
        history.push('/settings/mainmenu')
    }

    return (
        <DashboardWrapper>
            <PageWrapper
                title={
                    <div className='flex space-x-2'>
                        <BackButton />
                        <div className="mr-8"> {t('actions.edit')} {t('form.menu')} </div>
                    </div>}
            >
                <form className="lg:w-2/3 xl:w-1/2" onSubmit={handleSubmit(onAddMenu)}>
                    <SectionWrapper
                        title={t('form.status')}
                        actions={
                            <ToggleSwitch isEnabled={setIsEnabled} />

                        }
                    />
                    {/* Image Url */}
                    <SectionWrapper
                        title={t('form.image_url')}
                    >
                        <Input
                            placeholder={'https://www.example.com/images/image.png'}
                            id={"image_url"}
                            register={register("image_url", {
                                required: false,
                                pattern: {
                                    value: /^http[^ !@$^&()+=]+(.png|.jpeg|.jpg)$/,
                                    message: "Format supported .png , .jpg or .jpeg  \n , eg. https://example.com/logo.png "
                                }
                            })}
                            error={errors.image_url}
                            className="my-2"

                        />
                    </SectionWrapper>

                    {/* Title */}
                    <SectionWrapper
                        title={t('form.title')}
                    >
                        <Input
                            id="french.title"
                            label={<Language _key="fr" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.title')}
                            register={register("french.title", {
                                required: t('form.error_title')
                            })}
                            error={errors.french?.title}
                            className="my-2"
                        />
                        <Input
                            id="arabic.title"
                            label={<Language _key="ar" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.title')}
                            register={register("arabic.title", {
                                required: t('form.error_title')
                            })}
                            error={errors.arabic?.title}
                            className="my-2"

                        />
                        {/* <Input
                            id="arabic_dialect_ma.title"
                            label={<Language _key="drj" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.title')}
                            register={register("arabic_dialect_ma.title", {
                                required: t('form.error_title')
                            })}
                            error={errors.arabic_dialect_ma?.title}
                            defaultValue={data?.arabic_dialect_ma?.title}
                            className="my-2"

                        /> */}


                        <Input
                            id="english.title"
                            label={<Language _key="en" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.title')}
                            register={register("english.title", {
                                required: t('form.error_title')
                            })}
                            error={errors.english?.title}
                            className="my-2"
                        />

                    </SectionWrapper>

                    {/* Subtitle */}
                    <SectionWrapper
                        title={t('form.subtitle')}
                    >

                        <Input
                            id="french.subtitle"
                            label={<Language _key="fr" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.subtitle')}
                            register={register("french.subtitle", {
                                required: t('form.error_subtitle')
                            })}
                            error={errors.french?.subtitle}
                            className="my-2"
                        />

                        <Input
                            id="arabic.subtitle"
                            label={<Language _key="ar" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.subtitle')}
                            register={register("arabic.subtitle", {
                                required: t('form.error_subtitle')
                            })}
                            error={errors.arabic?.subtitle}
                            className="my-2"

                        />

                        {/* <Input
                            id="arabic_dialect_ma.subtitle"
                            label={<Language _key="drj" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.subtitle')}
                            register={register("arabic_dialect_ma.subtitle", {
                                required: t('form.error_subtitle')
                            })}
                            error={errors.arabic_dialect_ma?.subtitle}
                            className="my-2"

                        /> */}

                        <Input
                            id="english.subtitle"
                            label={<Language _key="fr" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.subtitle')}
                            register={register("english.subtitle", {
                                required: t('form.error_subtitle')
                            })}
                            error={errors.english?.subtitle}
                            className="my-2"
                        />

                    </SectionWrapper>

                    {/* button_label */}
                    <SectionWrapper
                        title={t('form.button_label')}
                    >

                        <Input
                            id="french.button_label"
                            label={<Language _key="fr" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.button_label')}
                            register={register("french.button_label", {
                                required: t('form.error_button_label')
                            })}
                            error={errors.french?.button_label}
                            className="my-2"
                        />

                        <Input
                            id="arabic.button_label"
                            label={<Language _key="ar" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.button_label')}
                            register={register("arabic.button_label", {
                                required: t('form.error_button_label')
                            })}
                            error={errors.arabic?.button_label}
                            className="my-2"

                        />

                        {/* <Input
                            id="arabic_dialect_ma.button_label"
                            label={<Language _key="drj" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.button_label')}
                            register={register("arabic_dialect_ma.button_label", {
                                required: t('form.error_button_label')
                            })}
                            error={errors.arabic_dialect_ma?.button_label}
                            className="my-2"

                        /> */}

                        <Input
                            id="english.button_label"
                            label={<Language _key="en" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.button_label')}
                            register={register("english.button_label", {
                                required: t('form.error_button_label')
                            })}
                            error={errors.english?.button_label}
                            className="my-2"
                        />

                    </SectionWrapper>

                    {/* card_response */}
                    <SectionWrapper
                        title={t('form.card_response')}
                    >

                        <TextArea
                            id="french.card_response"
                            label={<Language _key="fr" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.card_response')}
                            register={register("french.card_response", {
                                required: t('form.error_card_response')
                            })}
                            error={errors.french?.card_response}
                            className="my-2"
                        />

                        <TextArea
                            id="arabic.card_response"
                            label={<Language _key="ar" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.card_response')}
                            register={register("arabic.card_response", {
                                required: t('form.error_card_response')
                            })}
                            error={errors.arabic?.card_response}
                        />
{/* 
                        <TextArea
                            id="arabic_dialect_ma.card_response"
                            label={<Language _key="drj" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.card_response')}
                            register={register("arabic_dialect_ma.card_response", {
                                required: t('form.error_card_response')
                            })}
                            error={errors.arabic_dialect_ma?.card_response}
                        /> */}

                        <TextArea
                            id="english.card_response"
                            label={<Language _key="en" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.card_response')}
                            register={register("english.card_response", {
                                required: t('form.error_card_response')
                            })}
                            error={errors.english?.card_response}
                            className="my-2"
                        />

                    </SectionWrapper>

                    {/* Actions  */}


                    <div className="justify-end flex items-center mt-8">
                        <input type='button' value={t('actions.cancel')} onClick={onCancel}
                            className='font-medium  text-sm capitalize bg-gray-100 rounded  px-4 py-2  mx-2 border-1 border-gray-500  cursor-pointer hover:bg-gray-300 shadow'
                        />
                        <input
                            className='capitalize font-medium    text-white bg-blue-500 rounded  px-4 py-2  mx-2 border-1 border-blue-500 shadow-md  cursor-pointer hover:bg-blue-600'
                            type="submit" value={t('actions.create')} />
                    </div>
                </form>

            </PageWrapper>


            {addMenuStatus === "success" && <ToastAlert message={t('alert.success_operation')} type={'success'} timeOut={5000} />}
            {addMenuStatus === "error" && <ToastAlert message={t('alert.failed_operation')} type={'error'} timeOut={5000} />}

        </DashboardWrapper>


    );

}

export default AddMenuOption;